import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="border-t border-white/5 mt-24" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 py-12">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
                    <div className="col-span-2 md:col-span-1">
                        <Link to="/" className="flex items-center gap-2.5 mb-3" data-testid="footer-logo">
                            <div className="w-7 h-7 rounded-md bg-accent/10 border border-accent/30 flex items-center justify-center">
                                <Sparkles className="w-3.5 h-3.5 text-accent" strokeWidth={2} />
                            </div>
                            <span className="font-semibold text-zinc-100 tracking-tight text-sm">
                                listcraft<span className="text-accent">.</span>
                            </span>
                        </Link>
                        <p className="text-xs text-zinc-500 leading-relaxed max-w-[220px]">
                            AI-generated product listings for Amazon, Shopify, Etsy &amp; eBay sellers.
                        </p>
                    </div>

                    <div>
                        <div className="overline mb-4">Product</div>
                        <ul className="space-y-2.5 text-sm">
                            <li><Link to="/pricing" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="footer-pricing">Pricing</Link></li>
                            <li><Link to="/showcase" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="footer-showcase">Showcase</Link></li>
                            <li><Link to="/register" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="footer-register">Get started</Link></li>
                        </ul>
                    </div>

                    <div>
                        <div className="overline mb-4">Policies</div>
                        <ul className="space-y-2.5 text-sm">
                            <li><Link to="/shipping-policy" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="footer-shipping">Shipping Policy</Link></li>
                            <li><Link to="/refund-policy" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="footer-refund">Cancellation &amp; Refunds</Link></li>
                            <li><Link to="/terms" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="footer-terms">Terms of Service</Link></li>
                            <li><Link to="/privacy" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
                        </ul>
                    </div>

                    <div>
                        <div className="overline mb-4">Contact</div>
                        <ul className="space-y-2.5 text-sm">
                            <li>
                                <a href="mailto:arienterprises50@gmail.com" className="text-zinc-400 hover:text-zinc-100 transition-colors" data-testid="footer-email">
                                    arienterprises50@gmail.com
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="pt-6 border-t border-white/5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs font-mono text-zinc-600">
                    <div data-testid="footer-copyright">© {year} listcraft — built for sellers.</div>
                    <div data-testid="footer-powered-by" className="flex items-center gap-1.5">
                        <span>Powered by</span>
                        <span className="text-zinc-300">Ari Enterprises</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
